import React from 'react';
import { Container, Box, Paper, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function NotFound() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 15, mb: 4, textAlign: 'center' }}>
        <Paper
          elevation={0}
          sx={{
            p: 6,
            borderRadius: '16px',
            border: '1px solid rgba(30, 58, 138, 0.2)',
            boxShadow: '0 10px 40px rgba(30, 58, 138, 0.15), 0 20px 60px rgba(96, 165, 250, 0.12)',
            backgroundColor: '#fff',
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 100, color: '#1E3A8A', mb: 2 }} />
          <Typography variant="h2" gutterBottom sx={{ color: '#1E3A8A', fontWeight: 'bold' }}>
            404
          </Typography>
          <Typography variant="h5" gutterBottom>
            Oops! Page Not Found
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/')}
            sx={{ px: 4 }}
          >
            Go Back Home
          </Button>
        </Paper>
      </Box>
    </Container>
  );
}

export default NotFound;
